import { Navigate, useLocation } from 'react-router-dom';

/**
 * Builds the new URL for a moved route, keeping the rest of the path, the query,
 * and the hash (e.g. /templates/a/b?x=1 -> /design-templates/a/b?x=1).
 */
export const getLegacyRedirectPath = (from, to, { pathname, search, hash }) =>
	`${to}${pathname.slice(from.length)}${search}${hash}`;

const LegacyRedirect = ({ from, to }) => {
	const location = useLocation();
	return <Navigate to={getLegacyRedirectPath(from, to, location)} replace />;
};

export default LegacyRedirect;
